import { useCallback, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ChevronDown, Phone, Tag } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "./Logo";
import { PricingPanel } from "./PricingPanel";
import { PHONE, TEL, scrollToId } from "./data";

const NavLink = ({ id, label }) => {
  const { pathname } = useLocation();
  return (
    <Link
      to={`/#${id}`}
      data-testid={`nav-${id}`}
      onClick={(e) => { if (pathname === "/") { e.preventDefault(); scrollToId(id); } }}
      className="transition-colors hover:text-[#FFB000]"
    >
      {label}
    </Link>
  );
};

export const TopBar = () => {
  const [pricing, setPricing] = useState(false);
  const { pathname } = useLocation();
  const close = useCallback(() => setPricing(false), []);
  useEffect(() => { setPricing(false); }, [pathname]);
  const PricingTab = ({ className, testid }) => (
    <button
      data-testid={testid}
      aria-expanded={pricing}
      aria-controls="pricing-panel"
      onClick={() => setPricing((v) => !v)}
      className={`flex items-center gap-1.5 font-extrabold uppercase tracking-wide transition-colors ${pricing ? "text-[#FFB000]" : "text-white hover:text-[#FFB000]"} ${className}`}
    >
      <Tag className="h-4 w-4" strokeWidth={2.5} />Pricing
      <ChevronDown className={`h-4 w-4 transition-transform duration-300 ${pricing ? "rotate-180" : ""}`} strokeWidth={2.75} />
    </button>
  );
  return (
  <>
  <motion.header
    initial={{ y: -80 }}
    animate={{ y: 0 }}
    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
    className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-[#0D0D0B]/80 backdrop-blur-xl"
  >
    <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-3 px-4 sm:px-6">
      <Logo testid="header-logo" />
      <nav className="hidden items-center gap-7 text-sm font-semibold text-[#F2EEE6]/80 lg:flex">
        <PricingTab testid="nav-pricing" className="text-sm" />
        {[["services", "Services"], ["results", "Before & After"], ["area", "Service Area"], ["faq", "FAQ"]].map(([id, label]) => (
          <NavLink key={id} id={id} label={label} />
        ))}
      </nav>
      <div className="flex items-center gap-2">
        <button data-testid="top-bar-quote-cta" onClick={() => scrollToId("quote")} className="hidden rounded-full border border-white/20 px-4 py-2 text-sm font-bold text-[#F2EEE6] transition-colors hover:border-[#FFB000] hover:text-[#FFB000] md:block">
          Free Quote
        </button>
        <a data-testid="top-bar-phone-link" href={TEL} className="flex items-center gap-2 rounded-full bg-[#FFB000] px-4 py-2.5 text-sm font-extrabold text-[#0D0D0B] transition-transform active:scale-95 hover:bg-[#FFC233]">
          <Phone className="h-4 w-4" strokeWidth={2.75} />
          <span className="tabular-nums">{PHONE}</span>
        </a>
      </div>
    </div>
    <div className="border-t border-white/10 lg:hidden">
      <PricingTab testid="mobile-nav-pricing" className="h-10 w-full justify-center text-sm" />
    </div>
  </motion.header>
  <PricingPanel open={pricing} onClose={close} />
  </>
  );
};
